// import React, { useRef, useState } from "react";
// import emailjs from "@emailjs/browser";
// import toast, { Toaster } from "react-hot-toast";

// const InnerContactForm = () => {
//   const form = useRef();
//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const validateForm = () => {
//     const newErrors = {};
//     const formElements = form.current.elements;

//     if (!formElements.from_name.value.trim()) {
//       newErrors.from_name = "Name is required";
//     }

//     if (!formElements.from_email.value.trim()) {
//       newErrors.from_email = "Email is required";
//     } else if (
//       !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formElements.from_email.value)
//     ) {
//       newErrors.from_email = "Please enter a valid email";
//     }

//     // Phone number validation - must be exactly 10 digits
//     const phoneDigits = formElements.phone.value.replace(/\D/g, ""); // Remove all non-digit characters
//     if (!phoneDigits) {
//       newErrors.phone = "Phone number is required";
//     } else if (phoneDigits.length !== 10) {
//       newErrors.phone = "Phone number must be exactly 10 digits";
//     }

//     if (!formElements.subject.value.trim()) {
//       newErrors.subject = "Subject is required";
//     }

//     if (!formElements.message.value.trim()) {
//       newErrors.message = "Message is required";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const sendEmail = (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       toast.error("Please fill the form Correctly.");
//       return;
//     }

//     setIsSubmitting(true);

//     const promise = emailjs
//       .sendForm(
//         "service_g1cx9to",
//         "template_ikmochs",
//         form.current,
//         "ZLaxZZCxAPhJXlu2-"
//       )
//       .then((result) => {
//         return emailjs.sendForm(
//           "service_g1cx9to",
//           "template_g97luco",
//           form.current,
//           "ZLaxZZCxAPhJXlu2-"
//         );
//       });

//     toast
//       .promise(promise, {
//         loading: "Sending your message...",
//         success:
//           "Message sent successfully! Check your email for confirmation.",
//         error: "Failed to send message. Please try again later.",
//       })
//       .then(() => {
//         form.current.reset();
//         setErrors({});
//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       })
//       .finally(() => {
//         setIsSubmitting(false);
//       });
//   };

//   return (
//     <>
//       <form ref={form} onSubmit={sendEmail} noValidate>
//         <div className="form-grp">
//           <label htmlFor="name">
//             <i className="fas fa-user"></i>
//           </label>
//           <input
//             type="text"
//             id="name"
//             name="from_name"
//             placeholder="Name *"
//             className={errors.from_name ? "input-error" : ""}
//           />
//           {errors.from_name && (
//             <div className="error-text">{errors.from_name}</div>
//           )}
//         </div>

//         <div className="form-grp">
//           <label htmlFor="email">
//             <i className="fas fa-envelope"></i>
//           </label>
//           <input
//             type="email"
//             id="email"
//             name="from_email"
//             placeholder="Email *"
//             className={errors.from_email ? "input-error" : ""}
//           />
//           {errors.from_email && (
//             <div className="error-text">{errors.from_email}</div>
//           )}
//         </div>

//         <div className="form-grp">
//           <label htmlFor="phone">
//             <i className="fas fa-phone"></i>
//           </label>
//           <input
//             type="tel"
//             id="phone"
//             name="phone"
//             placeholder="Phone *"
//             className={errors.phone ? "input-error" : ""}
//           />
//           {errors.phone && <div className="error-text">{errors.phone}</div>}
//         </div>

//         <div className="form-grp">
//           <label htmlFor="subject">
//             <i className="fas fa-book-alt"></i>
//           </label>
//           <input
//             type="text"
//             id="subject"
//             name="subject"
//             placeholder="Subject *"
//             className={errors.subject ? "input-error" : ""}
//           />
//           {errors.subject && <div className="error-text">{errors.subject}</div>}
//         </div>

//         <div className="form-grp">
//           <label htmlFor="message">
//             <i className="fas fa-user-edit"></i>
//           </label>
//           <textarea
//             name="message"
//             id="message"
//             placeholder="How can we help you? Feel free to get in touch! *"
//             className={errors.message ? "input-error" : ""}
//           ></textarea>
//           {errors.message && <div className="error-text">{errors.message}</div>}
//         </div>

//         <button type="submit" className="btn" disabled={isSubmitting}>
//           {isSubmitting ? "Sending..." : "Send Message"} <span></span>
//         </button>
//       </form>

//       <Toaster position="top-center" />

//       <style jsx>{`
//         .input-error {
//           border-color: #ff4444;
//         }
//         .error-text {
//           color: #ff4444;
//           font-size: 0.8rem;
//           margin-top: 0.3rem;
//         }
//         button:disabled {
//           opacity: 0.7;
//           cursor: not-allowed;
//         }
//       `}</style>
//     </>
//   );
// };

// export default InnerContactForm;




import React, { useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";

const InnerContactForm = () => {
  const formRef = useRef();
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const form = formRef.current;

    const name = form["from_name"].value.trim();
    const phone = form["phone"].value.replace(/\D/g, "");
    const subject = form["subject"].value.trim();
    const message = form["message"].value.trim();

    if (!name) newErrors.from_name = "Name is required";
    if (!phone) newErrors.phone = "Phone number is required";
    else if (phone.length !== 10)
      newErrors.phone = "Phone number must be 10 digits";
    if (!subject) newErrors.subject = "Subject is required";
    if (!message) newErrors.message = "Message is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill all fields correctly.");
      return;
    }

    setIsSubmitting(true);

    const form = formRef.current;
    const name = form["from_name"].value;
    const phone = form["phone"].value;
    const subject = form["subject"].value;
    const message = form["message"].value;

    const fullMessage = `Name: ${name}\nPhone: ${phone}\n\nMessage:\n${message}`;

    const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=22a91a61d1@aec.edu.in&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(fullMessage)}`;

    try {
      window.open(gmailURL, "_blank");
      toast.success("Gmail opened. Please click 'Send' in Gmail.");
      form.reset();
      setErrors({});
    } catch (err) {
      toast.error("Failed to open Gmail.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <form ref={formRef} onSubmit={handleSubmit} noValidate>
        <div className="form-grp">
          <label htmlFor="name">
            <i className="fas fa-user"></i>
          </label>
          <input
            type="text"
            id="name"
            name="from_name"
            placeholder="Name *"
            className={errors.from_name ? "input-error" : ""}
          />
          {errors.from_name && (
            <div className="error-text">{errors.from_name}</div>
          )}
        </div>

        <div className="form-grp">
          <label htmlFor="phone">
            <i className="fas fa-phone"></i>
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Phone *"
            className={errors.phone ? "input-error" : ""}
          />
          {errors.phone && <div className="error-text">{errors.phone}</div>}
        </div>

        <div className="form-grp">
          <label htmlFor="subject">
            <i className="fas fa-book-alt"></i>
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            placeholder="Subject *"
            className={errors.subject ? "input-error" : ""}
          />
          {errors.subject && (
            <div className="error-text">{errors.subject}</div>
          )}
        </div>

        <div className="form-grp">
          <label htmlFor="message">
            <i className="fas fa-user-edit"></i>
          </label>
          <textarea
            name="message"
            id="message"
            placeholder="How can we help you? Feel free to get in touch! *"
            className={errors.message ? "input-error" : ""}
          ></textarea>
          {errors.message && (
            <div className="error-text">{errors.message}</div>
          )}
        </div>

        <button type="submit" className="btn" disabled={isSubmitting}>
          {isSubmitting ? "Preparing Gmail..." : "Send Message"} <span></span>
        </button>
      </form>

      <Toaster position="top-center" />

      <style jsx>{`
        .input-error {
          border-color: #ff4444;
        }
        .error-text {
          color: #ff4444;
          font-size: 0.8rem;
          margin-top: 0.3rem;
        }
        button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      `}</style>
    </>
  );
};

export default InnerContactForm;
